// extracted by mini-css-extract-plugin
export default {"auto-complete-wrapper":"MWJbcMVPxRIRk45v+vxyiA=="};